
import { getDistrict } from './api.js'

import pageApiData from './utils/pageApiData.js'

const [ _getDistrictFromServer, _getDistrict, _getDistrictSync ] = pageApiData.createFunctions(getDistrict, 'Unable to get district data from server.', function (code) { return elem => elem.code === code })

async function getAllDistricts() {
  return _getDistrictFromServer()
}

async function getDistrictByCode(code) {
  return (await _getDistrict(code))
}

function getDistrictByCodeSync(code) {
  return (_getDistrictSync(code))
}

export default {
  getDistrictFromServer: _getDistrictFromServer,
  getDistrict: _getDistrict,
  getDistrictSync: _getDistrictSync,

  getAllDistricts,
  getDistrictByCode,
  getDistrictByCodeSync,
}
